module.exports = __webpack_public_path__ + "img/dr-congo.6cf9e93a.svg";